import MovieCard from "@/components/feature/MovieCard";
import Skeleton from "@/components/base/Skeleton";
import EmptyState from "@/components/base/EmptyState";
import type { CatalogItem } from "@/types/catalog";

interface MovieGridProps {
  items: CatalogItem[];
  loading?: boolean;
  skeletonCount?: number;
  emptyTitle?: string;
  emptyDescription?: string;
  emptyActionLabel?: string;
  onEmptyAction?: () => void;
  columns?: string;
}

export default function MovieGrid({
  items,
  loading = false,
  skeletonCount = 10,
  emptyTitle = "暂无内容",
  emptyDescription,
  emptyActionLabel,
  onEmptyAction,
  columns = "grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5",
}: MovieGridProps) {
  if (loading) {
    return (
      <div className={`grid ${columns} gap-4 md:gap-5`}>
        {Array.from({ length: skeletonCount }).map((_, idx) => (
          <div key={idx} className="rounded-lg overflow-hidden border border-background-200">
            <Skeleton className="w-full aspect-[2/3] rounded-none" />
            <div className="p-3 space-y-2">
              <Skeleton className="h-4 w-3/4" />
              <Skeleton className="h-3 w-1/2" />
            </div>
          </div>
        ))}
      </div>
    );
  }

  if (items.length === 0) {
    return (
      <EmptyState
        title={emptyTitle}
        description={emptyDescription}
        actionLabel={emptyActionLabel}
        onAction={onEmptyAction}
      />
    );
  }

  return (
    <div className={`grid ${columns} gap-4 md:gap-5`}>
      {items.map((item) => (
        <MovieCard key={item.id} item={item} />
      ))}
    </div>
  );
}